import * as Yup from 'yup';
import { useState, useContext, useEffect, useMemo, useReducer } from 'react';
import { useSearchParams } from 'react-router-dom';
//
import { useFormik, Form, FormikProvider } from 'formik';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
//
import moment from 'moment';
// material
import { Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import {
  Stack,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  FormControl,
  IconButton,
  Divider,
  Box, Autocomplete,
  Typography,
  OutlinedInput,
  Chip,
  Radio, CircularProgress
} from '@material-ui/core';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from 'react-redux';
// hooks
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
//
import { getAnswerSummaryCommentApi, getComplianceByQuestionsApi, getCustomerRefDataTagsApi } from "../../../../_apis_/authApi.js/analytic_api"
import ScoreCardsContext from '../../../../contexts/ScoreCardsContext';
import { AnalyticContext } from '../../../../contexts/AnalyticContext';
import { DateRangeList } from "../../../../utils/filterUtilities";
import { handleScorecardFilterData } from '../../../../redux/slices/AnalyticsSlices/ScorecardFilterSlice';

// ----------------------------------------------------------------------

const useStyles = makeStyles(() => ({
  dropdownListStyle: {
    padding: 5
  },
  select: {
    backgroundColor: '#FFFFFF'
  },
  selectDisabled: {
    backgroundColor: '#E9ECEF'
  },
  textField: {
    backgroundColor: '#FFFFFF'
  },
  textFieldLock: {
    backgroundColor: '#E9ECEF'
  },
  selectLock: {
    backgroundColor: '#E9ECEF'
  }
}));

// ----------------------------------------------------------------------

export default function AnalyticsScorecardFilterDialog({
  addUserButton,
  setAddMode,
  closeAddUserDialog,
}) {

  const [searchParams, setSearchParams] = useSearchParams();
  const filterBy = [
    {
      id: 1,
      type: 'Score Date'
    },
    {
      id: 2,
      type: 'Event Date'
    },
    {
      id: 3,
      type: 'Last Edit Date'
    }
  ];

  const formulaType = [
    {
      id: 10,
      type: 'True'
    },
    {
      id: 20,
      type: 'Potential'
    }
  ];


  const {
    getScoreLogGroups,
    reportsScoreLogGroups,
    getScoreLogScorecards,
    scorecardSection,
    getSectionDropdown,
    reportsScoreLogScorecards,
    getScoreLogEventType,
    reportsScoreLogEventType,
    getScoreLogEventSubType,
    reportsScoreLogEventSubType,
    getScoreLogTeams,
    reportsScoreLogTeams,
    getScoreLogSupervisor,
    reportsScoreLogSupervisor,
    getScoreLogEmployee,
    reportsScoreLogEmployee,
    getScoreLogCategory,
    getScoreLogEvaluator,
    loadingState
  } = useContext(ScoreCardsContext);
  const {
    subModLabel,
    getQuestionTrend,
    setSelAnaScoreCardFilters,
    selScDuration,
    selectedDateAnaScRange,
    setSelectedDateAnaScRange,
    selectedScFilterBy,
    setselectedScFilter,
    selectedScFilter,
    setSelectedScFilterBy,
    selectedScGroupFilter,
    setSelectedScGroupFilter,
    selectedScTeamFilter,
    setSelectedScTeamFilter,
    selectedScSupervisorFilter,
    setSelectedScSupervisorFilter,
    selectedScFromDate,
    setSelectedScFromDate,
    selectedScToDate,
    setSelectedScToDate,
    selectedScFromWeek,
    setSelectedScFromWeek,
    selectedScToWeek,
    setSelectedScToWeek,
    selectedScSecFilter,
    setSelectedScSecFilter,
    getOverAllTrend,
    selectedScEventType,
    setSelectedScEventType,
    selectedScStaff,
    setSelectedScStaff,
    selectedScSubType,
    setSelectedScSubType,
    setFailAllOnly,
    getSectionTrend,
    getCausesTrend, failAllOnly,
    getCausesByScorecard,
    getCausesByScorecardGraph,
    getEventTypeTrend, selectedFlag,
    timeBtnGroupQueTrend, getDataTagsByScoreCard,
    selectedScFilterByValue,
    setSelectedScFilterByValue,
    setCommentData, setCommentType,
    commentType, getPerformanceAgainstTarget,
    setCommentLoading, dataTagByScoreCard,
    setDataTagByScoreCard,
    getDataTagsByEventData,
    selectedScHighlight, setSelectedScHighlight,
    setComplianceByQuestionData,
    setComplianceByDateType, setselectedDataTagFilter,
    setComplianceByLoading, selectedDataTagFilter,
    setCustomerRefDataTagData, selWeekMonthYearDuration,
    setCustomerRefDataTagLoading,
    selectedScMultipleFilter, setselectedScMultipleFilter,
    selectedScFormula, setSelectedScFormula,
    selectedScNumericValue, setSelectedScNumericValue,
    setNumeric,
  } = useContext(AnalyticContext);

  const { getQuestionsOfSection, scorecardQuestions, getQuestionsAnswerByStaff, questionsAnswerByStaff } = useContext(ScoreCardsContext);

  const [open, setOpen] = useState(false);
  const [circular, setCircular] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState();
  const [customFilters, setCustomFilters] = useState(false);
  const [fromWeekNo, setFromWeekNo] = useState([]);
  const [toWeekNo, setToWeekNo] = useState([]);
  // Data tags state
  const [isAnyOfTag, setIsAnyOfTag] = useState(true)
  const [isAllOfTag, setIsAllOfTag] = useState(false)

  const isMountedRef = useIsMountedRef();
  const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

  const newDispatch = useDispatch()

  const initialState = {
    openGroupField: false,
    openSingleScorecardField: false,
    openMultiScorecardField: false,
    openEventTypeField: false,
    openEventSubTypeField: false,
    openTeamField: false,
    openSupervisorField: false,
    openStaffField: false,
    openSectionField: false,
    openQuestionField: false,
    openEvalField: false,

  }

  const reducerFunc = (state, action) => {
    // console.log('state ==>', state, action)
    switch (action.type) {
      case 'SET_VALUE':
        return { ...state, ...action.payload };
      case 'RESET_VALUE':
        return initialState;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducerFunc, initialState)

  // helper function to update state value--
  const updateState = (key, value) => {
    dispatch({ type: 'SET_VALUE', payload: { [key]: value } });
  };

  // helper function to reset the state
  const resetState = (key, value) => {
    dispatch({ type: 'RESET_VALUE' });
  };

  const filterFieldsData = useSelector(state => state.ScorecardFilterSlice?.scorecardFilterData)
  console.log('filterFieldsData 4.1', filterFieldsData)

  const ReportSchema = Yup.object().shape({
    scoreCardMultiple: (subModLabel === 4.7 || subModLabel === 4.5) ? Yup.number().transform((value) => Number.isNaN(value) ? null : value).required('This value is required').nullable() : '',
    scoreCard: (subModLabel !== 4.7 && subModLabel !== 4.5) ? Yup.number().transform((value) => Number.isNaN(value) ? null : value).required('This value is required').nullable() : Yup.string(),
    group: (subModLabel === 4.1 || subModLabel === 4.2 || subModLabel === 4.3 || subModLabel === 4.7 ||
      subModLabel === 4.8 || subModLabel === '4.10' || subModLabel === 4.6 || subModLabel === 4.9 ||
      subModLabel === 4.11) ? Yup.number().transform((value) => Number.isNaN(value) ? null : value).required('This value is required').nullable() : Yup.string()
  });

  const formik = useFormik({
    initialValues: {
      id: '',
      dateRange: '',
      filterByRange: '',
      fromDate: '',
      toDate: '',
      fromWeek: '',
      toWeek: '',
      filterBy: '',
      group: '',
      teams: '',
      scoreCard: '',
      scoreCardMultiple: [],
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: '',
      staff: '',
      scoreCardCategory: '',
      evaluator: '',
      highlightValue: '',
      section: '',
      question: '',
      numericValues: '',
      formula: '',
      scoreCardQuestions: '',
      dataTag: [],
      reference: '',
      allOfTag: '',
      anyOfTag: '',
      groupField: {},
      teamField: {},
      singleScorecardField: {},
      multiScorecardField: [],
      eventField: {},
      eventSubField: {},
      supervisorField: {},
      sectionField: {},
      questionField: {},
      evaluatorField: {},
      staffField: {}
    },
    validationSchema: ReportSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      setCircular(true);
      // setSelectedScEventType(values?.eventType);
      // setSelectedScSubType(values?.eventTypeEventSubType);
      setSelectedScNumericValue(values?.numericValues)
      setNumeric(values?.numericValues)
      try {

        const scorecardFilterObj = {
          fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
          toDate: moment(values.toDate).format('YYYY-MM-DD'),
          dateRange: values?.dateRange,
          fromWeek: values.fromWeek,
          toWeek: values.toWeek,
          filterBy: values.filterBy,
          group: values.group,
          teams: values.teams,
          scoreCard: values.scoreCard,
          scoreCardMultiple: values?.scoreCardMultiple,
          scoreCardGroups: values?.group,
          eventType: values.eventType,
          eventTypeEventSubType: values.eventTypeEventSubType,
          scoreCardCategory: values.scoreCardCategory,
          evaluator: values.evaluator,
          page: '1',
          filterName: '',
          highlightValue: values.highlightValue,
          flag: selScDuration === 'quarter' ? 'year' : selScDuration,
          section: values.section || '',
          question: values.question || '',
          supervisor: values.supervisor,
          staff: values.staff,
          numericValues: values.numericValues || '',
          formula: values.formula || '',
          filterByRange: values.filterByRange,
          reference: values.reference,
          dataTag: values.dataTag || [],
          dataTagsOperator: values?.allOfTag || values?.anyOfTag || '',
          groupField: values.groupField,
          teamField: values.teamField,
          singleScorecardField: values.singleScorecardField,
          multiScorecardField: values.multiScorecardField,
          eventField: values?.eventField,
          eventSubField: values.eventSubField,
          supervisorField: values.supervisorField,
          sectionField: values.sectionField,
          questionField: values?.questionField,
          evaluatorField: values?.evaluatorField,
          staffField: values.staffField,
          subModule: subModLabel
        };
        if (subModLabel === 4.1) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration === 'quarter' ? 'year' : selScDuration,
            question: values.question || '',
            section: values.section || '',
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues || '',
            formula: values.formula || '',
            filterByRange: values.filterByRange,
            reference: values.reference,
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || ''
          };

          // redux thunk call---- to store filter state 
          newDispatch(handleScorecardFilterData(scorecardFilterObj))

          await getOverAllTrend(filterObj);
          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false);
          }
        } else if (subModLabel === 4.2) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            filterBy: values.filterBy,
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            // "staff": values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selWeekMonthYearDuration,
            question: values.question || '',
            section: values.section || '',
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues || '',
            formula: values.formula || '',
            reference: values.reference,
            filterByRange: values.filterByRange,
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || ''
          };
          // need to do something in the data tag, vlau.data tag
          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selWeekMonthYearDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          await getEventTypeTrend(filterObj);
          // setSelAnaScoreCardFilters({ ...values, scoreCard: values.scoreCard });
          handleClose();
          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false);
          }
        } else if (subModLabel === 4.3) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,

            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selectedFlag,
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues,
            formula: values.formula,
            reference: values.reference,
            filterByRange: values.filterByRange,
          };
          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selectedFlag
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          await getPerformanceAgainstTarget(filterObj);
          // setSelAnaScoreCardFilters(filterObj);

          handleClose();
        } else if (subModLabel === 4.4) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: timeBtnGroupQueTrend === 'quarter' ? 'year' : timeBtnGroupQueTrend,
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            formula: values.formula,
            reference: values.reference,
            filterByRange: values.filterByRange,
          };


          if (values?.anyOfTag || values?.allOfTag || values?.dataTag?.length > 0 || dataTagByScoreCard?.length > 0) {

            await getQuestionTrend({
              ...filterObj,
              dataTag: values.dataTag || '',
              dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
            });


          } else {
            await getQuestionTrend({
              ...filterObj,
              dataTag: '',
              dataTagsOperator: '10'
            });

          }

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: timeBtnGroupQueTrend === 'quarter' ? 'year' : timeBtnGroupQueTrend
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          handleClose();
        } else if (subModLabel === 4.5) {
          // setCircular(true);

          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCardMultiple: values.scoreCardMultiple,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration,
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues,
            reference: values.reference,
            formula: values.formula,
            dataTag: values.dataTag || '',
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || '10'
          };

          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selScDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          await getSectionTrend(filterObj);
          // setSelAnaScoreCardFilters(filterObj);
          // localStorage.setItem("selAnaScoreCardFilters", JSON.stringify({ ...filterObj }));
          handleClose();
        } else if (subModLabel === 4.6) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            dateRange: values.dateRange,
            filterByRange: values.filterByRange,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardMultiple: values.scoreCardMultiple,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            // "staff": values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration,
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            staff: values.staff,
            scoreCardQuestions: values.scoreCardQuestions,
            numericValues: values.numericValues,
            reference: values.reference,
            formula: values.formula
          };
          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selScDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          // setSelAnaScoreCardFilters(filterObj);
          try {
            setCommentData([]);
            setCommentLoading(true);
            const { data } = await getAnswerSummaryCommentApi(filterObj, commentType)
            if (data?.data?.length > 0) {
              setCommentData(data);
              setCommentLoading(false);
              // setSearchParams({ ...filterObj, scoreCardMultiple: JSON.stringify([values.scoreCard]) })
              handleClose();
            } else {
              setCommentData([]);
              setCommentLoading(false);
              handleClose();
            }
          } catch (err) {
            setCommentData([]);
            setCommentLoading(false);
            handleClose();
          }

        } else if (subModLabel === 4.7) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardMultiple: values.scoreCardMultiple,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            // "staff": values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration,
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues,
            reference: values.reference,
            formula: values.formula,
            filterByRange: values.filterByRange,
          };
          // setSearchParams(filterObj)

          if (values?.anyOfTag || values?.allOfTag ||
            values?.dataTag?.length > 0 ||
            dataTagByScoreCard?.length > 0) {
            filterObj.dataTag = values.dataTag || '';
            filterObj.dataTagsOperator = values.anyOfTag || values.allOfTag || '10';
          } else {
            filterObj.dataTag = '';
            filterObj.dataTagsOperator = '';
          }

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selScDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          await getCausesByScorecard(filterObj);
          await getCausesByScorecardGraph(filterObj);
          // setSelAnaScoreCardFilters(filterObj);
          // localStorage.setItem("selAnaScoreCardFilters", JSON.stringify({ ...filterObj }));
          handleClose();
        } else if (subModLabel === 4.8) {

          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            page: '1',
            filterName: '',
            supervisor: values.supervisor,
            staff: values.staff,
            question: values.question || '',
            section: values.section,
            scoreCardQuestions: values.scoreCardQuestions,
            flag: selectedFlag,
            numericValues: values.numericValues,
            reference: values.reference,
            dataTag: values.dataTag || '',
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || '10'
          };
          await getCausesTrend(filterObj)
          // setSelAnaScoreCardFilters(filterObj);
          // localStorage.setItem("selAnaScoreCardFilters", JSON.stringify({ ...filterObj }));

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selectedFlag
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          if (failAllOnly === true) {
            setFailAllOnly(!failAllOnly)
          }
          // setSearchParams(filterObj)

          handleClose();
        } else if (subModLabel === 4.9) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            dateRange: values.dateRange,
            filterByRange: values.filterByRange,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardMultiple: values.scoreCardMultiple,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            // "staff": values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration,
            question: values.question || '',
            section: values.section,
            staff: values.staff,
            supervisor: values.supervisor,
            scoreCardQuestions: values.scoreCardQuestions,
            numericValues: values.numericValues,
            formula: values.formula,
            reference: values.reference,
            dataTag: values.dataTag,

          };
          // setSelAnaScoreCardFilters(filterObj);
          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selScDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          try {
            setComplianceByQuestionData([])
            setComplianceByDateType("month")
            setComplianceByLoading(true);
            const { data } = await getComplianceByQuestionsApi(filterObj, "month")
            if (data?.compliance_data?.length > 0) {
              setComplianceByQuestionData(data);
              setComplianceByLoading(false);
              // setSearchParams({ ...filterObj, dataTag: JSON.stringify(values.dataTag), scoreCardMultiple: JSON.stringify([values.scoreCard]) });
              handleClose();
            } else {
              setComplianceByQuestionData([]);
              setComplianceByLoading(false);
              handleClose();
            }
          } catch (err) {
            setComplianceByQuestionData([]);
            setComplianceByLoading(false);
            handleClose();
          }

        } else if (subModLabel === "4.10") {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            question: values.question || '',
            section: values.section,
            supervisor: values.supervisor,
            staff: values.staff,
            numericValues: values.numericValues,
            formula: values.formula,
            filterByRange: values.filterByRange,
            dataTags: [values.dataTag],
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || '',
            reference: values.reference
          };
          // setSelAnaScoreCardFilters({ ...filterObj, scoreCard: values.scoreCard });
          // localStorage.setItem("selAnaScoreCardFilters", JSON.stringify({ ...filterObj }));

          // setSearchParams({ ...filterObj });

          // redux thunk call---- to store filter state 
          newDispatch(handleScorecardFilterData(scorecardFilterObj))

          await getDataTagsByEventData(filterObj);
          handleClose();
          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false);
          }
        } else if (subModLabel === 4.11) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            dateRange: values.dateRange,
            filterByRange: values.filterByRange,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCard,
            scoreCardMultiple: values.scoreCardMultiple,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            flag: selScDuration,
            question: values.question || '',
            section: values.section,
            staff: values.staff,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            formula: values.formula,
            scoreCardQuestions: values.scoreCardQuestions,
            reference: values.reference,
            dataTag: [values.dataTag],
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || '10',

          };
          // setSelAnaScoreCardFilters(filterObj);
          // setSearchParams(filterObj)

          // redux thunk call---- to store filter state 
          const updatedFilterObj = {
            ...scorecardFilterObj,
            flag: selScDuration
          }
          newDispatch(handleScorecardFilterData(updatedFilterObj))

          try {
            setCustomerRefDataTagData([])
            setCustomerRefDataTagLoading(true);
            const { data } = await getCustomerRefDataTagsApi(filterObj)
            if (data?.customer_references?.length > 0) {
              setCustomerRefDataTagData(data);
              // setSearchParams({ ...filterObj, dataTag: [values.dataTag], scoreCardMultiple: JSON.stringify([values.scoreCard]) });
              setCustomerRefDataTagLoading(false);
              handleClose();
            } else {
              setCustomerRefDataTagData([]);
              setCustomerRefDataTagLoading(false);
              handleClose();
            }
          } catch (err) {
            setCustomerRefDataTagData([]);
            setCustomerRefDataTagLoading(false);
            handleClose();
          }

        }

        setCircular(false);

      } catch (error) {
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: error.message });
        }
        // setCircular(false);
      }

    },
    enableReinitialze: true
  });


  const { errors, touched, values, setFieldValue, getFieldValue, handleSubmit, isSubmitting, getFieldProps } = formik;

  useEffect(() => {
    if (open) {
      if (filterFieldsData?.dateRange) {
        setFieldValue('dateRange', filterFieldsData?.dateRange);
        setFieldValue('fromDate', filterFieldsData?.fromDate);
        setFieldValue('toDate', filterFieldsData?.toDate);
      } else {
        setFieldValue('dateRange', 'This Month');
        setFieldValue('fromDate', moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().startOf('month').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().endOf('month').format('YYYY-MM-DD'));
        // setSelectedDateAnaScRange('This Month');
      }

      if (filterFieldsData?.dateRange === 'Custom Date Range') {
        setCustomFilters(true);
        formik.setFieldValue("fromWeek", filterFieldsData?.fromWeek);
        formik.setFieldValue("toWeek", filterFieldsData?.toWeek);
      }

      if (selectedScFilterBy) {
        setFieldValue('filterByRange', filterFieldsData?.filterByRange);
        setFieldValue('filterBy', filterFieldsData?.filterBy);
      } else {
        setFieldValue('filterByRange', 'Score Date');
        setFieldValue('filterBy', 'created_at');
      }

      if (filterFieldsData?.group) {

        setFieldValue('group', filterFieldsData?.group);
      } else {
        setFieldValue('group', '');
      }
      if (subModLabel === 4.4 || subModLabel === 4.5) {
        if (!filterFieldsData.groupField?.id) {
          setFieldValue("groupField", {
            name: 'All', id: ''
          });
        } else {
          setFieldValue("groupField", filterFieldsData?.groupField);
        }
      } else if (filterFieldsData?.groupField) {
        setFieldValue("groupField", filterFieldsData?.groupField);
      } else {
        setFieldValue("groupField", {});
      }


      if (filterFieldsData?.teams) {
        setFieldValue('teams', filterFieldsData?.teams);
      } else {
        setFieldValue('teams', '');
      }

      if (filterFieldsData?.teamField) {
        setFieldValue("teamField", filterFieldsData?.teamField);
      } else {
        setFieldValue("teamField", { id: '', name: "All" });
      }

      if (filterFieldsData?.supervisor) {
        setFieldValue('supervisor', filterFieldsData?.supervisor);
      } else {
        setFieldValue('supervisor', '');
      }

      if (filterFieldsData?.supervisorField) {
        setFieldValue("supervisorField", filterFieldsData?.supervisorField);
      } else {
        setFieldValue("supervisorField", { supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' });
      }

      if (filterFieldsData?.section) {
        setFieldValue('section', filterFieldsData?.section);
      } else {
        setFieldValue('section', '');
      }

      if (filterFieldsData?.sectionField) {
        setFieldValue('sectionField', filterFieldsData?.sectionField)
      } else {
        setFieldValue('sectionField', {
          id: '',
          name: 'All',
          scoreCard: '',
          type: ''
        })

      }

      if ((filterFieldsData?.singleScorecardField || filterFieldsData?.multiScorecardField?.length !== 0)) {
        if (filterFieldsData?.singleScorecardField) {

          setFieldValue("singleScorecardField", filterFieldsData?.singleScorecardField)
        } else if (filterFieldsData?.multiScorecardField) {
          setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

        }
      } else {
        setFieldValue("singleScorecardField", {});
      }

      if (filterFieldsData?.scoreCard) {
        setFieldValue("scoreCard", filterFieldsData?.scoreCard)
        // setFieldValue("scoreCard", filterFieldsData?.scoreCard || (selectedScMultipleFilter?.length > 0 ? selectedScMultipleFilter[0] : ''))
        const filterScoreCardObj = {
          "fromDate": moment(filterFieldsData?.fromDate).format('YYYY-MM-DD'),
          "toDate": moment(filterFieldsData?.toDate).format('YYYY-MM-DD'),
          "filterBy": filterFieldsData.filterBy || 'created_at',
          "scoreCard": filterFieldsData?.scoreCard ?? '',
        }
        getDataTagsByScoreCard(filterScoreCardObj);
      } else {
        setFieldValue("scoreCard", '');
      }

      if (filterFieldsData?.multiScorecardField) {
        setFieldValue("multiScorecardField", filterFieldsData?.multiScorecardField);
        setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

      } else {
        setFieldValue("multiScorecardField", []);
      }

      if (filterFieldsData?.scoreCardMultiple) {
        setFieldValue("scoreCardMultiple", filterFieldsData?.scoreCardMultiple)
        const filterScoreCardObj = {
          "fromDate": moment(filterFieldsData?.fromDate).format('YYYY-MM-DD'),
          "toDate": moment(filterFieldsData?.toDate).format('YYYY-MM-DD'),
          "filterBy": filterFieldsData.filterBy || 'created_at',
          "scoreCard": filterFieldsData?.scoreCardMultiple ?? '',
        }
        getDataTagsByScoreCard(filterScoreCardObj);
      } else {
        setFieldValue("scoreCardMultiple", []);
      }

      if (filterFieldsData?.eventType) {
        setFieldValue("eventType", filterFieldsData?.eventType);
      } else {
        setFieldValue("eventType", '');
      }

      if (filterFieldsData?.eventField) {
        setFieldValue("eventField", filterFieldsData?.eventField);
      } else {
        setFieldValue("eventField", {
          eventType: '',
          eventTypeEventType: "All",
          scoreCard: ''
        })
      }

      if (filterFieldsData?.eventTypeEventSubType) {
        setFieldValue('eventTypeEventSubType', filterFieldsData?.eventTypeEventSubType);
      } else {
        setFieldValue('eventTypeEventSubType', '');

      }

      if (filterFieldsData?.eventSubField) {
        setFieldValue("eventSubField", filterFieldsData?.eventSubField);
      } else {
        setFieldValue("eventSubField", {
          eventSubType: '',
          subType: "All",
          scorecard: ''
        })
      }

      if (filterFieldsData?.staff) {
        setFieldValue('staff', filterFieldsData?.staff)
      } else {
        setFieldValue('staff', '')
      }

      if (filterFieldsData?.staffField) {
        setFieldValue('staffField', filterFieldsData?.staffField)
      } else {
        setFieldValue("staffField", {
          staffUserFirstName: 'All',
          staffUserLastName: '',
          supervisor: ''
        });
      }


      if (filterFieldsData?.highlightValue) {
        setFieldValue('highlightValue', filterFieldsData?.highlightValue);
      } else {
        setFieldValue('highlightValue', '');
      }

      if (filterFieldsData?.dataTag) {
        setFieldValue('dataTag', filterFieldsData?.dataTag);
      } else {
        setFieldValue('dataTag', '');

      }

      if (filterFieldsData?.dataTagsOperator !== '20') {
        setIsAnyOfTag(true)
        setIsAllOfTag(false)
        setFieldValue('anyOfTag', '10')
        setFieldValue('allOfTag', '');

      } else {
        setIsAnyOfTag(false)
        setIsAllOfTag(true)

        setFieldValue('anyOfTag', '');
        setFieldValue('allOfTag', '20');
      }

      setFieldValue('scoreCardCategory', '');
      setFieldValue('evaluator', '');

      if (filterFieldsData?.question) {
        setFieldValue('question', filterFieldsData?.question)
      } else {
        setFieldValue('question', '');
      }

      if (filterFieldsData?.questionField) {
        setFieldValue('questionField', filterFieldsData?.questionField)
      } else {
        setFieldValue('questionField', {
          id: '',
          question: 'All',
        });
      }

      if (filterFieldsData?.formula) {
        setFieldValue('formula', filterFieldsData?.formula);
      } else {
        setFieldValue('formula', 10);
      }

      if (filterFieldsData?.numericValues) {
        setFieldValue('numericValues', filterFieldsData?.numericValues);
      } else {
        setFieldValue('numericValues', false);
      }
      if (filterFieldsData?.reference) {
        setFieldValue('reference', filterFieldsData?.reference);
      } else {
        setFieldValue('reference', '');
      }
    }
  }, [open]);

  useEffect(() => {

    if (open) {
      const arrFromWeek = [];
      const arrToWeek = [];
      if (formik.values.fromWeek > moment().week()) {
        for (let i = 1; i <= formik.values.fromWeek; i) {
          arrFromWeek.push(i);
          i += 1;
        }
        setFromWeekNo(arrFromWeek);
      } else {
        for (let i = 1; i <= moment().week(); i) {
          arrFromWeek.push(i);
          i += 1;
        }
        setFromWeekNo(arrFromWeek);
      }

      if (formik.values.toWeek > moment().week()) {
        for (let i = 1; i <= formik.values.toWeek; i) {
          arrToWeek.push(i);
          i += 1;
        }
        setToWeekNo(arrToWeek);
      } else {
        for (let i = 1; i <= moment().week(); i) {
          arrToWeek.push(i);
          i += 1;
        }
        setToWeekNo(arrToWeek);
      }
    }



    const filterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      group: values.group,
      teams: values.teams,
      scoreCard: values.scoreCard,
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: values.supervisor,
      staff: values.staff,
      scoreCardCategory: values.scoreCardCategory,
      evaluator: values.evaluator,
      highlightValue: values.highlightValue,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    const scoreCardfilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      group: values.group,
      teams: values.teams,
      scoreCard: '',
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: values.supervisor,
      staff: values.staff,
      scoreCardCategory: values.scoreCardCategory,
      evaluator: values.evaluator,
      highlightValue: values.highlightValue,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    const groupFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      group: '',
      teams: values.teams,
      scoreCard: values.scoreCard,
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: values.supervisor,
      staff: values.staff,
      scoreCardCategory: values.scoreCardCategory,
      evaluator: values.evaluator,
      highlightValue: values.highlightValue,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    const teamFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      group: values.group,
      teams: '',
      scoreCard: values.scoreCard,
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: values.supervisor,
      staff: values.staff,
      scoreCardCategory: values.scoreCardCategory,
      evaluator: values.evaluator,
      highlightValue: values.highlightValue,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    const supFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      group: values.group,
      teams: values.teams,
      scoreCard: (subModLabel === 4.7 || subModLabel === 4.5) ? values.scoreCardMultiple.toString() : values.scoreCard,
      eventType: values.eventType,
      eventTypeEventSubType: values.eventTypeEventSubType,
      supervisor: '',
      staff: values.staff,
      scoreCardCategory: values.scoreCardCategory,
      evaluator: values.evaluator,
      highlightValue: values.highlightValue,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    const evntTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": (subModLabel === 4.7 || subModLabel === 4.5) ? values.scoreCardMultiple.toString() : values.scoreCard,
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }

    const evntSubTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": (subModLabel === 4.7 || subModLabel === 4.5) ? values.scoreCardMultiple.toString() : values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }

    // if (formik.values.fromDate && formik.values.toDate && formik.values.filterBy) {
    // getScoreLogGroups(groupFilterObj);
    // getScoreLogTeams(teamFilterObj);
    // getScoreLogScorecards(scoreCardfilterObj);
    // getScoreLogEventType(evntTypeFilterObj);
    // getScoreLogEventSubType(evntSubTypeFilterObj);
    // getScoreLogSupervisor(supFilterObj);
    // getScoreLogEmployee(filterObj);
    // getScoreLogCategory(filterObj);
    // getScoreLogEvaluator(filterObj);
    // getScoreLogEmployee(filterObj);
    // if (values.scoreCard) {
    //   getSectionDropdown(values.scoreCard);
    // }
    // }
  }, [formik?.values]);

  console.log('values---4th', values)
  // Open user dialog modal
  const handleClickOpen = () => {
    setOpen(true);
  };

  // Close user dialog modal
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);

      if (!setAddMode) {
        closeAddUserDialog(false);
      }
    }
  };


  const handleCloseFields = () => {
    updateState('openGroupField', false)
    updateState('openSingleScorecardField', false)
    updateState('openMultiScorecardField', false)
    updateState('openEventTypeField', false)
    updateState('openEventSubTypeField', false)
    updateState('openTeamField', false)
    updateState('openSupervisorField', false)
    updateState('openStaffField', false)
    updateState('openSectionField', false)
    updateState('openQuestionField', false)
    updateState('openEvalField', false)

  };

  const handleDateRangeChange = (event) => {
    // Resetting remaining fields
    setFieldValue('group', '');
    setFieldValue('teams', '');
    setFieldValue('scoreCard', '');
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue("scoreCardMultiple", []);
    // setselectedScFilter('')
    // setselectedScMultipleFilter([])
    setFieldValue('dataTag', []);
    // setDataTagByScoreCard([]);

    // redux state fields
    // setFieldValue("groupField", {});
    if (subModLabel === 4.4 || subModLabel === 4.5) {
      setFieldValue("groupField", {
        name: 'All', id: ''
      });
    } else {
      setFieldValue("groupField", {});
    }
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffField", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });


    const dateRange = event.target.value;
    setFieldValue('dateRange', dateRange);
    switch (dateRange) {
      case 'Today':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().format('YYYY-MM-DD'));
        setSelectedScToDate(moment().format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Today');
        break;
      case 'Yesterday':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Yesterday');
        break;
      case 'This Week':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('week').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().startOf('week').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('This Week');
        break;
      case 'Last Week':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Last Week');
        break;
      case 'This Month':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().startOf('month').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('This Month');
        break;
      case 'Last Month':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Last Month');
        break;
      case 'This Quarter':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('This Quarter');
        break;
      case 'Last Quarter':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Last Quarter');
        break;
      case 'This Year':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('year').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().startOf('year').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('This Year');
        break;
      case 'Last Year':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedScFromDate(moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setSelectedScToDate(moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedDateAnaScRange('Last Year');
        break;
      case 'Custom Date Range':
        setCustomFilters(true);
        formik.setFieldValue("fromDate", moment());
        formik.setFieldValue("toDate", moment());

        setSelectedScFromDate(moment());
        setSelectedScToDate(moment());

        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("fromWeek", 1)
          setSelectedScFromWeek(1);
        }
        else {
          setFieldValue("fromWeek", moment().year(moment().format('YYYY')).week());
          setSelectedScFromWeek(moment().year(moment().format('YYYY')).week());
        }
        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("toWeek", 1)
          setSelectedScToWeek(1)
        }
        else {
          setFieldValue("toWeek", moment().year(moment().format('YYYY')).week());
          setSelectedScToWeek(moment().year(moment().format('YYYY')).week());
        }
        setSelectedDateAnaScRange('Custom Date Range');
        break;
      default:
        setFieldValue('fromDate', moment().format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().format('YYYY-MM-DD'));
        break;
    }
  };


  const handleFilterByChange = (event) => {

    // Resetting remaining fields
    setFieldValue('scoreCard', '');
    setFieldValue("scoreCardMultiple", []);

    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('dataTag', []);
    setDataTagByScoreCard([]);

    const filterBy = event.target.value;
    switch (filterBy) {
      case 'Score Date':
        setFieldValue('filterByRange', 'Score Date');
        setFieldValue('filterBy', 'created_at');
        setSelectedScFilterBy('Score Date');
        setSelectedScFilterByValue('created_at')
        break;
      case 'Event Date':
        setFieldValue('filterByRange', 'Event Date');
        setFieldValue('filterBy', 'event_date');
        setSelectedScFilterBy('Event Date');
        setSelectedScFilterByValue('event_date')
        break;
      case 'Last Edit Date':
        setFieldValue('filterByRange', 'Last Edit Date');
        setFieldValue('filterBy', 'updated_at');
        setSelectedScFilterBy('Last Edit Date');
        setSelectedScFilterByValue('updated_at')
        break;
      default:
        setFieldValue('filterByRange', 'Last Edit Date');
        setFieldValue('filterBy', 'updated_at');
        setSelectedScFilterBy('updated_at');
        setSelectedScFilterByValue('updated_at')
        break;
    }

  };

  const handleOpenGroupFields = async () => {

    const groupFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    updateState('openGroupField', true)
    await getScoreLogGroups(groupFilterObj);

  };

  const handleGroupChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('teams', '');
    setFieldValue('scoreCard', '');
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('dataTag', []);
    setFieldValue('dataTagsOperator', '')
    setFieldValue("scoreCardMultiple", []);
    setFieldValue('multiScorecardField', []);


    // setselectedScFilter('')
    // setselectedScMultipleFilter([])
    setFieldValue('group', newVal?.id ?? '');

    setFieldValue('groupField', newVal)
    // setDataTagByScoreCard([]);
    // setSelectedScGroupFilter(newVal?.id ?? '');

    // redux state fields
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffField", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });

  };

  const handleOpenTeamFields = () => {
    updateState('openTeamField', true)

    const teamFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogTeams(teamFilterObj)
  }

  const handleTeamChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('scoreCard', '');
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('dataTag', []);
    setFieldValue('dataTagsOperator', '10')

    // setFieldValue("scoreCardMultiple", []);
    // setselectedScFilter('')
    // setselectedScMultipleFilter([])
    setFieldValue('teams', newVal?.id);

    setFieldValue('teamField', newVal)

    // setSelectedScTeamFilter(event.target.value);
    // setDataTagByScoreCard([]);

    // redux state fields
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffField", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });
  };

  const handleOpenSupervisorField = () => {
    updateState('openSupervisorField', true)
    const supFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": '',
      "staff": values.staff,
      "scoreCardCategory": '',
      "evaluator": values.evaluator,
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogSupervisor(supFilterObj);
  }

  const handleSupervisorChange = (event, newVal) => {
    setFieldValue("supervisor", newVal?.supervisor);

    setFieldValue("supervisorField", newVal);
    // setSelectedSupervisorFilter(newVal?.supervisor);
  };

  const handleOpenSectionField = () => {
    updateState('openSectionField', true)
    // if(values?.scoreCardSingle) {
    getSectionDropdown(values?.scoreCard);
    // }
  }
  const handleSectionChange = (event, newVal) => {
    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });
    setFieldValue('question', '')

    setFieldValue('section', newVal?.id)

    setFieldValue('sectionField', newVal)
  };

  const handleHighlightChange = (event) => {
    setFieldValue('highlightValue', event.target.value);
    // setSelectedScHighlight(event.target.value)
  };

  const handleOpenQuestionField = () => {
    updateState('openQuestionField', true)

    getQuestionsAnswerByStaff(values.scoreCard, values.section);
  }
  const handleQuestions = (e, newVal) => {
    setFieldValue('question', newVal.id)

    setFieldValue('questionField', newVal)
    // setUserLev(event.target.value);
  }

  const handleDataTags = (event) => {
    setFieldValue("dataTag", event.target.value);
    setselectedDataTagFilter(event.target.value);
    localStorage.setItem('selectedDataTag', JSON.stringify(event.target.value))
  }

  const handleAnyOfTag = (event) => {
    setFieldValue('allOfTag', '')
    setFieldValue('anyOfTag', '10')
    setIsAnyOfTag(true)
    setIsAllOfTag(false)
  }

  const handleAllOfTag = () => {
    setFieldValue('dataTag', [])
    setFieldValue('allOfTag', '20')
    setIsAnyOfTag(false)
    setIsAllOfTag(true)
  }

  const handleOpenMultiScorecardFields = async () => {
    updateState('openMultiScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }
  // console.log('error---->', errors, JSON.stringify(values.group), typeof values.group, values)
  // console.log('reportsScoreLogScorecards 4', reportsScoreLogScorecards)
  const handleScorecardMultipleChange = (event, newValue) => {
    // Resetting remaining fields
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('dataTag', []);
    // setDataTagByScoreCard([]);
    // localStorage.setItem('selectedDataTag', JSON.stringify([]))
    // setselectedDataTagFilter([])

    const value = []
    const allValue = [];
    newValue?.map(option => {
      value.push(option?.scoreCard)
      allValue.push(option)
      return 0
    });

    setFieldValue("multiScorecardField", allValue)
    setFieldValue("singleScorecardField", allValue?.length > 0 ? allValue[0] : {})

    setFieldValue("scoreCardMultiple", value ?? []);
    setFieldValue("scoreCard", value?.length > 0 ? value[0] : '');


    // setselectedScMultipleFilter(value ?? []);
    // setselectedScFilter(value?.length > 0 ? value[0] : '');


    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "scoreCard": value ?? '',
    }
    if (value) {
      getDataTagsByScoreCard(filterScoreCardObj)

    }

    // redux state fields
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });
    setFieldValue('sectionField', {
      id: '',
      name: 'All',
      scoreCard: '',
      type: ''
    })
  };

  const handleOpenSingleScorecardFields = async () => {
    updateState('openSingleScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }


  const handleScorecardChange = (event, newValue) => {
    // Resetting remaining fields
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('dataTag', []);

    // setDataTagByScoreCard([]);
    // localStorage.setItem('selectedDataTag', JSON.stringify([]))
    // setselectedDataTagFilter([])
    setFieldValue("scoreCard", newValue?.scoreCard ?? '');
    setFieldValue("scoreCardMultiple", [newValue?.scoreCard]);

    setFieldValue('singleScorecardField', newValue)
    setFieldValue("multiScorecardField", [newValue] ?? [])
    // setselectedScFilter(newValue?.scoreCard);
    // setselectedScMultipleFilter([newValue?.scoreCard]);


    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "scoreCard": newValue?.scoreCard ?? '',
    }
    if (newValue?.scoreCard) {
      getDataTagsByScoreCard(filterScoreCardObj)
    }

    // redux state fields
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue('questionField', {
      id: '',
      question: 'All',
    });
    setFieldValue('sectionField', {
      id: '',
      name: 'All',
      scoreCard: '',
      type: ''
    })
  };

  const handleOpenEventTypeField = () => {
    updateState('openEventTypeField', true)
    const evntTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEventType(evntTypeFilterObj);

  }

  const handleEventTypeChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');

    setFieldValue('eventType', newVal?.eventType);
    setFieldValue('eventField', newVal);

    // setSelectedScEventType(event.target.value);

    // redux state fields
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
  };


  const handleOpenEventSubTypeField = () => {
    updateState('openEventSubTypeField', true)
    const evntSubTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEventSubType(evntSubTypeFilterObj);

  }

  const handleSubTypeChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');

    setFieldValue('eventSubField', newVal)
    setFieldValue('eventTypeEventSubType', newVal?.eventSubType);
    // setSelectedScSubType(event.target.value);
  };

  const handleOpenStaffFields = () => {
    updateState('openStaffField', true)
    const empFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": values.evaluator,
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEmployee(empFilterObj);

  }

  const handleAdvancedFilters = (event) => {
    setAdvanceFilters((advanceFilters) => !advanceFilters);
  };

  const renderOptions = (props, option) => {
    return <li {...props} key={option?.scoreCard} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
      {loadingState?.scorecardLoading ? 'Loading...' : option?.scoreCardName}
    </li>

  }

  const renderGroupOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.groupLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderTeamOptions = (props, option) => {
    // console.log('props & option', props, option, loadingState)
    return <li {...props} key={option?.id}>
      {!loadingState?.teamLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderEventOptions = (props, option) => {
    // console.log('option====>', option, props)
    return <li {...props} key={option?.eventType}>
      {
        loadingState?.eventTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.eventTypeEventType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }


  const renderEventSubOptions = (props, option) => {
    // console.log('option====>213', option, props)
    return <li {...props} key={option?.eventSubType}>
      {
        loadingState?.eventSubTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.subType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }

  const renderSupervisorOptions = (props, option) => {
    return <li {...props} key={option?.supervisor}>
      {!loadingState?.supervisorLoading ? `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` : 'Loading...'}
    </li>
  }

  const renderStaffOptions = (props, option) => {
    return <li {...props} key={option?.supervisor}>
      {!loadingState?.staffLoading ? `${option.staffUserFirstName} ${option.staffUserLastName}` : 'Loading...'}
    </li>
  }

  const renderSectionOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.sectionLoading ? option?.name ?? '--' : 'Loading...'}
    </li>
  }

  const renderQuestionOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.questionLoading ? option?.question : 'Loading...'}
    </li>
  }
  return (
    <div>
      {addUserButton && (
        <Button variant="contained" onClick={handleClickOpen} className="halloween-animation">
          Filter
        </Button>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle sx={{ pb: 2 }}>
              {' '}
              <h3>Analytics Report Filter </h3>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500]
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: '20px' }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ p: 0, justifyContent: 'end' }}>
                  <Button startIcon={advanceFilters ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    sx={{ p: 0 }}
                    onClick={handleAdvancedFilters}>
                    {advanceFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
                  </Button>
                </Stack>
                <Divider />

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="date-range-label">Date Range</InputLabel>
                    <Select
                      // defaultValue='This Month'
                      labelId="date-range-label"
                      id="demo-select-small"
                      value={values.dateRange}
                      label="Date Range"
                      {...getFieldProps('dateRange')}
                      onChange={(e) => {
                        handleDateRangeChange(e);
                      }}
                    >
                      {DateRangeList?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.dateRange}>
                          {item.dateRange}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="filter-by-label">Filter By</InputLabel>
                    <Select
                      defaultValue="Score Date"
                      labelId="filter-by-label"
                      id="demo-select-small"
                      value={values.filterByRange}
                      label="Filter By"
                      {...getFieldProps('filterByRange')}
                      onChange={handleFilterByChange}
                    >
                      {filterBy?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.type}>
                          {item.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                {customFilters && <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Box sx={{ width: "50%" }}>
                      <DesktopDatePicker
                        label="Date From"
                        inputFormat="yyyy/MM/dd"
                        name="fromDate"
                        disableFuture
                        {...getFieldProps('fromDate')}
                        onChange={(newValue) => {
                          setFieldValue("group", '');
                          if (moment(newValue).format('MM-DD') === '01-01') {
                            formik.setFieldValue("fromWeek", 1)
                            setSelectedScFromWeek(1)
                          } else {

                            formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                            setSelectedScFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());

                          }
                          setFieldValue("fromDate", newValue);
                          setSelectedScFromDate(newValue)
                          if (moment(newValue, "YYYY-MM-DD").isAfter(formik.values.toDate)) {
                            formik.setFieldValue("toDate", newValue)
                            setSelectedScToDate(newValue);
                            if (moment(newValue).format('MM-DD') === '01-01') {
                              formik.setFieldValue("toWeek", 1)
                              setSelectedScToWeek(1)

                            } else {
                              formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                              setSelectedScToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                            }

                          }
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                      {formik.errors.eventDate && formik.touched.eventDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.eventDate}</Typography>}

                    </Box>

                    <Box sx={{ width: "50%" }}>
                      <DesktopDatePicker
                        label="Date To"
                        inputFormat="yyyy/MM/dd"
                        name="toDate"
                        disableFuture
                        {...getFieldProps('toDate')}
                        onChange={(newValue) => {
                          setFieldValue("group", '')

                          if (moment(newValue).format('MM-DD') === '01-01') {
                            formik.setFieldValue("toWeek", 1)
                            setSelectedScToWeek(1)
                          } else {
                            formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                            setSelectedScToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                          }
                          setFieldValue("toDate", newValue);
                          setSelectedScToDate(newValue);

                          // Extract year from full date
                          const fullDate = moment(newValue);
                          const extractyear = fullDate.year();

                          if (moment(newValue, "YYYY-MM-DD").isBefore(formik.values.fromDate) && /^\d{4}$/.test(extractyear)) {
                            formik.setFieldValue("fromDate", moment(newValue).format('YYYY-MM-DD'))
                            setSelectedScFromDate(moment(newValue).format('YYYY-MM-DD'));
                            if (moment(newValue).format('MM-DD') === '01-01') {
                              formik.setFieldValue("fromWeek", 1)
                              setSelectedScFromWeek(1)

                            } else {
                              formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                              setSelectedScFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                            }

                          }
                        }}

                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                      {formik.errors.eventDate && formik.touched.eventDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.eventDate}</Typography>}

                    </Box>
                  </Stack>
                </LocalizationProvider>}
                {customFilters && <Stack direction="row" sx={{ width: "100%", mb: 2 }} spacing={2}>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      required
                      value={formik.values.fromWeek}
                      multiple={false}
                      select
                      name="fromWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("fromWeek", e.target.value);
                        setSelectedScFromWeek(e.target.value);
                        setSelectedScFromDate(moment().week(e.target.value).startOf('week'));
                        formik.setFieldValue("fromDate", moment().week(e.target.value).startOf('week'));
                      }}

                    >
                      {fromWeekNo?.map((item) => (
                        <MenuItem key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}

                    </TextField>
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      multiple={false}
                      value={formik.values.toWeek}
                      required
                      select
                      name="toWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("toWeek", e.target.value);
                        setSelectedScToWeek(e.target.value);
                        setSelectedScToDate(moment().week(e.target.value).endOf('week'));
                        formik.setFieldValue("toDate", moment().week(e.target.value).endOf('week'));
                      }}

                    >
                      {toWeekNo?.map((item) => (
                        <MenuItem disabled={formik.values.fromWeek > item} key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}
                    </TextField>
                  </Box>

                </Stack>}

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>

                    <Autocomplete
                      fullWidth
                      open={state?.openGroupField}
                      onOpen={handleOpenGroupFields}
                      onClose={handleCloseFields}
                      // value={selectedGroup ?? null}
                      value={(() => {
                        if (reportsScoreLogGroups) {
                          if (subModLabel === 4.4 || subModLabel === 4.5) {
                            const concatedObj = [{ name: 'All', id: '' }, ...reportsScoreLogGroups]
                            return concatedObj?.find((option) => option?.id === values?.group)
                          }
                          return reportsScoreLogGroups?.find((option) => option?.id === values?.group);
                        }

                        // If API not loaded
                        if (subModLabel === 4.4 || subModLabel === 4.5) {
                          if (!values.groupField?.id) {
                            return { ...values.groupField, name: 'All', id: '' }
                          }
                        }
                        return values.groupField;

                      })()}
                      options={
                        (() => {
                          if (reportsScoreLogGroups) {
                            if (subModLabel === 4.4 || subModLabel === 4.5) {
                              return [{ name: 'All', id: '' }, ...reportsScoreLogGroups];
                            }
                            return reportsScoreLogGroups;
                          }
                          // If API not loaded
                          if (subModLabel === 4.4 || subModLabel === 4.5) {
                            if (!values.groupField?.id) {
                              return [{ ...values.groupField, name: 'All', id: '' }]
                            }

                          }
                          return [values.groupField];
                        })()
                      }
                      // options={groupOptions}
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderGroupOptions}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(event, newValue) => {
                        handleGroupChange(event, newValue);
                      }}
                      id="controllable-states-demo"
                      name="group"
                      renderInput={(params) => <TextField {...params} label="Group"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                        // error={Boolean(touched.group && errors.group)}
                        error={values?.group === ''}
                        helperText={values?.group === '' ? errors.group : null}
                        // onBlur={formik.handleBlur}
                        required
                      />}
                    />

                  </FormControl>

                  <FormControl fullWidth>
                    <Autocomplete
                      fullWidth
                      open={state?.openTeamField}
                      onOpen={handleOpenTeamFields}
                      onClose={handleCloseFields}
                      value={
                        reportsScoreLogTeams ?
                          ([{
                            name: 'All', id: ''
                          }].concat(reportsScoreLogTeams))?.find((option) => option?.id === values?.teams)
                          :
                          values?.teamField ?? null
                      }
                      options={
                        (() => {
                          if (reportsScoreLogTeams) return [{ name: 'All', id: '' }, ...reportsScoreLogTeams];

                          // If API not loaded
                          if (values?.teamField) return [values.teamField];

                          return [{}];
                        })()
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderTeamOptions}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, newVal) => handleTeamChange(e, newVal)}
                      renderInput={(params) =>
                        <TextField {...params} label="Teams"
                          popoverProps={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          variant="outlined"

                        />}

                    />

                  </FormControl>
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {(subModLabel === 4.7 || subModLabel === 4.5) && <FormControl fullWidth>
                    <Autocomplete
                      multiple
                      freeSolo
                      open={state?.openMultiScorecardField}
                      onOpen={handleOpenMultiScorecardFields}
                      onClose={handleCloseFields}
                      // value={reportsScoreLogScorecards?.filter((option) => values?.scoreCard?.includes(option?.scoreCard))}
                      value={
                        reportsScoreLogScorecards
                          ? reportsScoreLogScorecards?.filter((option) =>
                            values?.scoreCardMultiple?.includes(option?.scoreCard)
                          )
                          : filterFieldsData?.multiScorecardField?.filter((option) =>
                            values?.scoreCardMultiple?.includes(option?.scoreCard)
                          )
                      }
                      name='scoreCard'
                      fullWidth
                      options={reportsScoreLogScorecards ?? filterFieldsData?.multiScorecardField ?? []}
                      getOptionLabel={(option) => option?.scoreCardName || ""}
                      renderOption={renderOptions}
                      onChange={(event, newValue) => {
                        handleScorecardMultipleChange(event, newValue);
                      }}
                      id="controllable-states-demo"
                      isOptionEqualToValue={(option, value) => String(option?.scoreCard) === String(value?.scoreCard)}
                      renderTags={(value, getTagProps) => {
                        return value.map((option, index) => (
                          <Chip
                            variant="outlined"
                            label={typeof option === "string" ? option : option?.scoreCardName}
                            {...getTagProps({ index })}
                          />
                        ));
                      }}
                      renderInput={(params) => <TextField {...params} label="Scorecard"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto',
                          }
                        }}
                        variant="outlined"
                        error={((values?.scoreCardMultiple?.length === 0) && true)}
                        helperText={(values?.scoreCardMultiple?.length === 0) && 'This value is required'}
                        onBlur={formik.handleBlur}
                        required
                      />}

                    />

                    {/* {(touched.scoreCardMultiple && errors.scoreCardMultiple) ?
                      // {(errors.scoreCardMultiple) ?
                      <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>
                        This value is required
                      </Typography>
                      : null} */}
                  </FormControl>}


                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    {(subModLabel !== 4.7 && subModLabel !== 4.5) &&
                      <Autocomplete
                        open={state?.openSingleScorecardField}
                        onOpen={handleOpenSingleScorecardFields}
                        onClose={handleCloseFields}
                        fullWidth
                        value={reportsScoreLogScorecards ?
                          (reportsScoreLogScorecards)?.find((option) => option?.scoreCard === values?.scoreCard) :
                          [values?.singleScorecardField]?.find((option) => option?.scoreCard === values?.scoreCard)
                        }

                        options={reportsScoreLogScorecards ?? []}
                        getOptionLabel={(option) => option?.scoreCardName || ""}
                        renderOption={renderOptions}
                        onChange={(event, newValue) => {
                          handleScorecardChange(event, newValue)

                        }}
                        isOptionEqualToValue={(option, value) => {
                          // console.log('option & value', option, value)
                          let equalOptions
                          if (option?.scoreCard) {
                            equalOptions = option?.scoreCard === value?.scoreCard
                          } else {
                            equalOptions = filterFieldsData?.singleScorecardField?.scoreCard === value?.scoreCard
                          }
                          return equalOptions
                        }}
                        id="controllable-states-demo"
                        renderInput={(params) => <TextField {...params} label="Scorecard"
                          popoverProps={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          error={((values?.scoreCard === '') && true)}
                          helperText={values?.scoreCard === '' && 'This value is required'}
                          variant="outlined"
                          // error={Boolean((touched.scoreCardSingle && errors.scoreCardSingle))}
                          // helperText={(touched.scoreCardSingle && errors.scoreCardSingle)}
                          required
                          onBlur={formik.handleBlur}

                        />}
                      />

                    }
                    {/* {formik.errors.scoreCard && formik.touched.scoreCard && values?.scoreCard === '' &&
                      <Typography variant="caption" sx={{ color: "red", ml: 1 }}>
                        This value is required
                      </Typography>} */}

                  </FormControl>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: '0px' }}>
                  {
                    (dataTagByScoreCard?.length > 0) && <> <FormControl fullWidth>
                      <InputLabel shrink id="demo-multiple-name-label">Data Tag(s)</InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        // freeSolo
                        value={selectedDataTagFilter !== null ? selectedDataTagFilter : []}
                        name='dataTag'
                        {...getFieldProps('dataTag')}
                        onChange={handleDataTags}
                        input={<OutlinedInput notched label="Data Tag(s)" />}
                      >
                        {dataTagByScoreCard?.map((item, i) => (
                          <MenuItem key={i} id={item.dataTags} value={item.dataTags}>
                            {item.dataTagsName}
                          </MenuItem >
                        ))}
                      </Select>
                    </FormControl>
                    </>
                  }
                </Stack>

                {dataTagByScoreCard?.length > 0 && <Stack direction={{ sm: 'row' }} spacing={0}>
                  <FormControlLabel
                    name="anyOfTag"
                    sx={{ marginLeft: '0px', marginRight: '0px' }}
                    // value="10"
                    control={<Radio />}
                    label="Any of the Tags"
                    checked={isAnyOfTag}
                    onChange={handleAnyOfTag}
                  />

                  <FormControlLabel
                    name="allOfTag"
                    sx={{ marginLeft: '0px', marginRight: '0px' }}
                    // value="20"
                    control={<Radio />}
                    label="All of the Tags"
                    onChange={handleAllOfTag}
                    checked={isAllOfTag}

                  />
                </Stack>}

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <Autocomplete
                      open={state?.openEventTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventTypeField}
                      value={
                        reportsScoreLogEventType ? ([{
                          eventType: '',
                          eventTypeEventType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventType))?.find((options) => options?.eventType === values?.eventType)
                          : values?.eventField ?? null
                      }
                      options={reportsScoreLogEventType ? ([{
                        eventType: '',
                        eventTypeEventType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventType)) : [values?.eventField]}
                      getOptionLabel={(option) =>
                        option?.eventTypeEventType
                          ? `${option.eventTypeEventType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventOptions}

                      onChange={(e, newVal) => handleEventTypeChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option & value', option, value)
                        let equalOptions
                        if (option?.eventType) {
                          equalOptions = option?.eventType === value?.eventType
                        } else {
                          equalOptions = filterFieldsData?.eventField?.eventType === value?.eventType
                        }
                        return equalOptions
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }

                    />

                  </FormControl>
                  <FormControl fullWidth>
                    <Autocomplete
                      open={state?.openEventSubTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventSubTypeField}
                      value={
                        reportsScoreLogEventSubType ? ([{
                          eventSubType: '',
                          subType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventSubType))?.find((options) => options?.eventSubType === values?.eventTypeEventSubType)
                          : values?.eventSubField
                      }
                      options={reportsScoreLogEventSubType ? ([{
                        eventSubType: '',
                        subType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventSubType)) : [values?.eventSubField]}
                      getOptionLabel={(option) =>
                        option?.subType || option?.scorecard
                          ? `${option.subType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventSubOptions}

                      onChange={(e, newVal) => handleSubTypeChange(e, newVal)}
                      // isOptionEqualToValue={(option, value) => option?.eventSubType === value?.eventSubType}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option & value', option, value)
                        let equalOptions
                        if (option?.eventType) {
                          equalOptions = option?.eventSubType === value?.eventSubType
                        } else {
                          equalOptions = filterFieldsData?.eventSubField?.eventSubType === value?.eventSubType
                        }
                        return equalOptions
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Sub Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }
                    />

                  </FormControl>

                </Stack>

                {advanceFilters && (
                  <>
                    {(subModLabel !== 4.9) && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <FormControl fullWidth>
                        <Autocomplete
                          open={state?.openSupervisorField}
                          onClose={handleCloseFields}
                          onOpen={handleOpenSupervisorField}
                          // value={values.supervisor}
                          value={
                            reportsScoreLogSupervisor ?
                              ([{
                                supervisorUserFirstName: 'All',
                                supervisorUserLastName: '',
                                supervisor: ''
                              }].concat(reportsScoreLogSupervisor))?.find((option) => option?.supervisor === values?.supervisor)
                              :
                              values?.supervisorField ?? null
                          }
                          options={
                            (() => {
                              if (reportsScoreLogSupervisor) return [{ supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' }, ...reportsScoreLogSupervisor];

                              // If API not call
                              if (values?.supervisorField) return [values.supervisorField];

                              return [{}];
                            })()
                          }
                          getOptionLabel={(option) => `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` || ""}
                          renderOption={renderSupervisorOptions}

                          onChange={(e, newVal) => handleSupervisorChange(e, newVal)}
                          isOptionEqualToValue={(option, value) => option?.supervisor === value?.supervisor}

                          renderInput={(params) => <TextField {...params} label="Supervisor"
                            popoverprops={{
                              style: {
                                bottom: 0,
                                overflowY: 'auto'
                              }
                            }}
                            variant="outlined"
                          />
                          }

                        />

                      </FormControl>
                    </Stack>}
                    {
                      (subModLabel === "4.10" || subModLabel === 4.11) && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <FormControl fullWidth>
                          <TextField
                            name='Reference'
                            id="outlined-error"
                            label="Reference"
                            variant="outlined"
                            {...getFieldProps('reference')}
                            error={Boolean(touched.reference && errors.reference)}
                            helperText={touched.reference && errors.reference}
                          />
                        </FormControl>

                      </Stack>
                    }

                    {(subModLabel === 4.9) && <FormControl sx={{ width: "100%" }}>
                      <Autocomplete
                        fullWidth
                        open={state?.openStaffField}
                        onOpen={handleOpenStaffFields}
                        onClose={handleCloseFields}
                        value={(() => {
                          if (reportsScoreLogEmployee) {
                            return reportsScoreLogEmployee?.find((option) => option?.staff === values?.staff)
                          }

                          // if not API loaded and not with "All" value staff fields
                          if (values?.staffField?.staffUserFirstName !== 'All') {
                            return values?.staffField
                          }

                          return ''
                        })()}

                        options={(() => {
                          if (reportsScoreLogEmployee) return reportsScoreLogEmployee ?? []

                          // if not API loaded and not with "All" value staff fields
                          if (values?.staffField?.staffUserFirstName !== 'All') {
                            return [values?.staffField]
                          }
                          return []
                        })()}

                        getOptionLabel={(option) =>
                          option?.staffUserFirstName || option?.staffUserLastName
                            ? `${option.staffUserFirstName} ${option.staffUserLastName}`
                            : ''
                        }
                        renderOption={renderStaffOptions}
                        isOptionEqualToValue={(option, value) => option?.staff === value?.staff}
                        onChange={(e, newVal) => {
                          formik.setFieldValue('staff', newVal?.staff)
                          setFieldValue('staffField', newVal)
                        }
                        }
                        renderInput={(params) =>
                          <TextField {...params} label="Employee"
                            popoverProps={{
                              style: {
                                bottom: 0,
                                overflowY: 'auto'
                              }
                            }}
                            variant="outlined"
                            error={Boolean(touched.staff && errors.staff)}
                            helperText={touched.staff && errors.staff}
                            required
                          />}

                      />

                    </FormControl>
                    }

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      {(subModLabel === 4.4 || subModLabel === 4.8 || subModLabel === 4.9) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            open={state?.openSectionField}
                            onClose={handleCloseFields}
                            onOpen={handleOpenSectionField}
                            value={(() => {
                              if (scorecardSection) {
                                const obj = [{
                                  id: '',
                                  name: 'All',
                                  scoreCard: '',
                                  type: ''
                                }].concat(scorecardSection)
                                return obj?.find((options) => options?.id === values?.section)
                              }
                              return values.sectionField
                            })()}

                            options={
                              (() => {
                                if (scorecardSection) {
                                  const obj = [{
                                    id: '',
                                    name: 'All',
                                    scoreCard: '',
                                    type: ''
                                  }].concat(scorecardSection)
                                  return obj
                                }
                                if (values.sectionField) {
                                  return [values.sectionField]

                                }
                              })()}

                            getOptionLabel={(option) =>
                              option?.name
                            }
                            renderOption={renderSectionOptions}

                            onChange={(e, newVal) => handleSectionChange(e, newVal)}
                            isOptionEqualToValue={(option, value) => {
                              let equalOptions
                              if (option?.id) {
                                equalOptions = option?.id === value?.id
                              } else {
                                equalOptions = filterFieldsData?.sectionField?.id === value?.id
                              }
                              return equalOptions
                            }}
                            renderInput={(params) => <TextField {...params} label="Sections"
                              popoverprops={{
                                style: {
                                  bottom: 0,
                                  overflowY: 'auto'
                                }
                              }}
                              variant="outlined"
                            />
                            }

                          />

                        </FormControl>
                      )}
                      {(subModLabel === 4.8) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            open={state?.openQuestionField}
                            onClose={handleCloseFields}
                            onOpen={handleOpenQuestionField}
                            value={(() => {
                              if (questionsAnswerByStaff?.length) {
                                const obj = [{ id: '', question: 'All' }, ...questionsAnswerByStaff];
                                return obj.find(option => option.id === values?.question) || null;
                              }
                              return values?.questionField || null;
                            })()}

                            options={
                              (() => {
                                if (questionsAnswerByStaff) {
                                  const obj = [{
                                    id: '',
                                    question: 'All',
                                  }].concat(questionsAnswerByStaff)
                                  return obj
                                }
                                if (values?.questionField) {
                                  return [values?.questionField]
                                }

                              })()}

                            getOptionLabel={(option) =>
                              option?.question
                            }
                            renderOption={renderQuestionOptions}

                            onChange={(e, newVal) => handleQuestions(e, newVal)}
                            isOptionEqualToValue={(option, value) => {
                              let equalOptions
                              if (option?.id) {
                                equalOptions = option?.id === value?.id
                              } else {
                                equalOptions = filterFieldsData?.questionField?.id === value?.id
                              }
                              return equalOptions
                            }}
                            renderInput={(params) => <TextField {...params} label="Questions"
                              popoverprops={{
                                style: {
                                  bottom: 0,
                                  overflowY: 'auto'
                                }
                              }}
                              variant="outlined"
                            />
                            }

                          />

                          {/* {formik.errors.scoreCardQuestions && formik.touched.scoreCardQuestions ? <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>{formik.errors.scoreCardQuestions}</Typography> : null} */}
                        </FormControl>
                      )}
                    </Stack>

                    {(subModLabel === 4.4 || subModLabel === 4.1 || subModLabel === 4.2 || subModLabel === 4.3 || subModLabel === 4.5) && (subModLabel !== "4.10") && (
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        {subModLabel !== 4.8 &&
                          <FormControl fullWidth>
                            <TextField
                              fullWidth
                              type='number'
                              label="Highlight Below"
                              {...getFieldProps('highlightValue')}
                              error={Boolean(touched.highlightValue && errors.highlightValue)}
                              helperText={touched.highlightValue && errors.highlightValue}
                              onChange={handleHighlightChange}
                            />
                          </FormControl>
                        }
                        {subModLabel !== 4.1 && subModLabel !== 4.2 && subModLabel !== 4.3 &&
                          <FormControl fullWidth>
                            <InputLabel shrink id="group-label">
                              Formula
                            </InputLabel>
                            <Select
                              labelId="group-label"
                              id="demo-select-small"
                              displayEmpty
                              input={<OutlinedInput notched label="Event Type" />}
                              value={values.formula}
                              {...getFieldProps('formula')}
                              onChange={(event) => { setFieldValue('formula', event.target.value); setSelectedScFormula(event.target.value) }}
                            >
                              {formulaType?.map((item) => (
                                <MenuItem key={item.id} id={item.id} value={item.id}>
                                  {item.type}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        }
                      </Stack>

                    )}

                    {subModLabel !== 4.1 && subModLabel !== 4.2 && subModLabel !== 4.3 && subModLabel !== "4.10" &&
                      <FormControlLabel
                        label="Numeric Values"
                        control={
                          <Checkbox
                            checked={values.numericValues}
                            {...getFieldProps('numericValues')} size="small" />
                        }
                        sx={{ width: '26%' }}
                      />
                    }

                  </>
                )}
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => {
                  handleClose();
                }}
                color="inherit"
              >
                Cancel
              </Button>
              <Button disabled={circular} type="submit" variant="contained" loading={isSubmitting}>
                Apply
                {circular && <CircularProgress size={14} sx={{ ml: 1 }} />}
              </Button>
              {/* <Button type="submit" variant="contained" loading={isSubmitting}>
                Apply
              </Button> */}
            </DialogActions>
          </Form>
        </FormikProvider>
      </Dialog>
    </div>
  );
}